<template lang="html">
  <div id="" style="min-height: 65vh;">
    <div class="container text-center py-5 my-5">
      <h1 class="my-5 py-5 title-s1 c-primary">PROXIMAMENTE</h1>
    </div>
  </div>
</template>

<script>
export default {
}
</script>
